<template>
  <div class="search">
    <div class="search-bar">
      <div class="search-type" @click="setTypeVisible">
        <p>{{['产品', '配方', '索样'][this.typeIndex]}}</p>
        <img src="../../assets/images/nicon-arrow-down2.png"/>
      </div>
      <div class="search-input">
        <input type="text" placeholder="搜索产品、牌号、品牌、CAS、生产商" @focus="showHistoryAction" @blur="hideHistoryAction" @keydown="searchAction" v-model="modelKeyword"/>
        <img class="search-icon" src="../../assets/images/icon-search2.png" alt="" @click="searchByBtnAction">
      </div>
    </div>
    <div class="search-type-list" v-show="typeVisible">
      <p :class="{active: typeIndex == 0}" @click="selectTypeItem(0)"><span></span> 产品</p>
      <p :class="{active: typeIndex == 1}" @click="selectTypeItem(1)"><span></span> 配方</p>
      <p :class="{active: typeIndex == 2}" @click="selectTypeItem(2)"><span></span> 索样</p>
    </div>
    <div class="search-list" v-show="searchListVisible">
      <ul>
        <li v-for="(item, index) in historyList" :key="'search-history-item' + index" @click="goToSearchResult(item)">{{item}}</li>
      </ul>
    </div>
    <div class="mask" v-show="typeVisible || searchListVisible" @click="closeAllPopup"></div>
  </div>
</template>

<script>
  import { getStorage, setStorage } from '../../utils/storage.js';
  export default {
    props: {
      attrKeyword: {
        type: String
      },
      attrTypeIndex: {
        type: null
      },
      callback: {
        type: Function
      }
    },
    data() {
      return {
        typeIndex: this.attrTypeIndex || 0, // 搜索类型 0 产品 1 配方 2 索样
        typeVisible: false, // 搜索类型可视化
        searchListVisible: false, // 搜索列表可视化
        historyList: [], // 历史记录
        modelKeyword: this.attrKeyword || '' // 搜索关键字
      }
    },
    mounted() {
      this.getHistory();
    },
    methods:{
      // 获取历史记录
      getHistory() {
        let storage = getStorage('searchHistory')
        if (storage) {
          this.historyList = storage;
        }
      },
      // 显示隐藏搜索类型
      setTypeVisible() {
        this.typeVisible = !this.typeVisible;
      },
      // 关闭所有弹层
      closeAllPopup() {
        this.typeVisible = false;
        this.searchListVisible = false;
      },
      /**
       * 选择类型
       * @param {number} index 0 产品 1 配方
       */
      selectTypeItem(index) {
        this.typeIndex = index;
        this.typeVisible = false;
      },
      // 搜索
      searchAction(e) {
        if (e.keyCode === 13) {
         this.searchHandle();
        }
      },
      // 搜索处理
      searchHandle() {
        if (this.modelKeyword != '') {
          this.historyList.unshift(this.modelKeyword);
          if (this.historyList.length > 5) {
            this.historyList.pop();
          }
          setStorage('searchHistory', this.historyList);
        }
        if (this.callback) {
          this.callback(this.modelKeyword, this.typeIndex);
        } else {
          this.$router.push({path: '/search/result', query: {keyword: this.modelKeyword, type: this.typeIndex}});
        }
      },
      // 显示历史记录
      showHistoryAction() {
        this.searchListVisible = true;
      },
      // 因此历史记录
      hideHistoryAction() {
        this.searchListVisible = false;
      },
      /**
       * 跳转到搜索结果页面
       * @param {Object} searchValue 搜索内容
       */
      goToSearchResult(searchValue) {
        if (this.callback) {
          this.callback(searchValue, this.typeIndex);
        } else {
          this.$router.push({path: '/search/result', query: {keyword: searchValue, type: this.typeIndex}});
        }
      },
      // 搜索图标搜索
      searchByBtnAction() {
        this.searchHandle();
      }
    }
  }
</script>

<style lang="less" scoped="scoped">
  .search {
    position: relative;
    z-index: 1;
    .mask {
      position: fixed;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      width: 100%;
      height: 100%;
      z-index: 0;
    }
  }
  .search-bar {
    display: flex;
    align-items: center;
    background-color: #eaedf7;
    border-radius: 20rem;
    padding: 1rem;
    height: 2rem;
    line-height: 2rem;
    margin: 0 2rem;
    box-shadow: inset 0 0 6px rgba(0, 0, 0, .4);
    .search-type {
      border-right: 1px solid #b9c0d4;
      width: 22%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 1.2rem;
      color: #999;
      img {
        display: block;
        width: 1rem;
        margin-left: .5rem;
      }
    }
    .search-input {
      border-left: 1px solid #fff;
      flex: 1;
      display: flex;
      align-items: center;
      input {
        display: block;
        width: 100%;
        padding: 0 .5rem;
        box-sizing: border-box;
        background: none;
        border: 0;
        outline: none;
      }
      .search-icon {
        diplay: block;
        width: 1.6rem;
        margin-right: .5rem;
      }
    }
  }
  .search-type-list {
    position: absolute;
    top: 5.2rem;
    left: 2rem;
    background-color: #eaedf6;
    border-radius: 5px;
    box-shadow: 0 0 5px rgba(0, 0, 0, .8);
    padding: 1rem 1.5rem;
    z-index: 10;
    &:before {
      content: '';
      border-top: 8px transparent dashed;
      border-left: 6px transparent dashed;
      border-bottom: 8px #eaedf6 solid;
      border-right: 6px transparent dashed;
      position: absolute;
      top: -1.6rem;
      left: 50%;
      margin-left: -5px;
    }
    p {
      font-size: 1.4rem;
      border-bottom: 1px solid #ddd;
      padding: 1rem 0;
      color: #666;
      &:last-child {
        border-bottom: 0;
        border-top: 1px solid #fff;
      }
      &.active {
        span {
          border-color: #597eff;
          &:before {
            content: '';
            display: block;
            position: absolute;
            top: 50%;
            left: 50%;
            width: .8rem;
            height: .8rem;
            margin: -.4rem 0 0 -.4rem;
            border-radius: 50%;
            background-color: #597eff;
          }
        }
      }
      span {
        position: relative;
        border: 1px solid #aaa;
        border-radius: 50%;
        display: inline-block;
        vertical-align: middle;
        width: 1.4rem;
        height: 1.4rem;
        margin-right: .5rem;
      }
    }
  }
  .search-list {
    position: absolute;
    z-index: 10;
    top: 5.2rem;
    left: 2rem;
    right: 2rem;
    background-color: #eaedf6;
    border-radius: 1rem;
    box-shadow: 0 0 4px rgba(0, 0, 0, .6);
    height: 17rem;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    ul {
      padding: 1rem 2rem;
      li {
        font-size: 1.5rem;
        color: #666;
        line-height: 3rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/search.vue